import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

/**
 * Landing for /doctor/reset?t=<token>. Exchanges the token for a new
 * password + fresh JWT, mirroring the partner reset flow. One-time use +
 * 1h expiry are enforced backend-side.
 */
export default function DoctorReset() {
  const [sp] = useSearchParams();
  const token = sp.get("t") || "";
  const nav = useNavigate();
  const { login } = useApp();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [ok, setOk] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (pw.length < 8) return toast.error("Mínimo 8 caracteres");
    if (pw !== pw2) return toast.error("Las contraseñas no coinciden");
    setLoading(true);
    try {
      const r = await api.post("/doctor/password/reset", { token, password: pw });
      login(r.data.token, "doctor", { email: r.data.email });
      setOk(true);
      setTimeout(() => nav("/doctor/panel"), 800);
    } catch (e) { toast.error(e.response?.data?.detail || "Error"); }
    finally { setLoading(false); }
  };

  useEffect(() => { if (!token) toast.error("Enlace inválido"); }, [token]);

  return (
    <div className="max-w-md mx-auto px-4 py-12">
      <Card><CardContent className="p-6 sm:p-8">
        {ok ? (
          <p data-testid="doctor-reset-success" className="text-center text-sm text-slate-700">
            Contraseña actualizada. Redirigiendo…
          </p>
        ) : (
          <>
            <h1 className="text-2xl font-bold text-slate-900 mb-1">Nueva contraseña</h1>
            <p className="text-sm text-slate-500 mb-5">Elige una contraseña de al menos 8 caracteres.</p>
            <div className="space-y-3">
              <div><Label>Nueva contraseña</Label>
                <Input data-testid="doctor-reset-pw" type="password" value={pw}
                       onChange={e => setPw(e.target.value)}/></div>
              <div><Label>Confirmar</Label>
                <Input data-testid="doctor-reset-pw2" type="password" value={pw2}
                       onChange={e => setPw2(e.target.value)}/></div>
            </div>
            <Button data-testid="doctor-reset-submit-final" onClick={submit} disabled={loading || !token}
                    className="w-full mt-5 h-11 bg-blue-600 hover:bg-blue-700 font-semibold">
              Guardar
            </Button>
          </>
        )}
      </CardContent></Card>
    </div>
  );
}
